<p-drawer [(visible)]="show" position="right" (onHide)="hideOnAction()">
    <ng-template pTemplate="header">{{
        "components.global.filtersSidebar.title" | translate
    }}</ng-template>
    <ng-template pTemplate="content">
        <!-- Nao possui filtros avançados -->
        <ng-template [ngIf]="!canFilter">
            <div class="container-filters" filters>
                <div class="row pd-3">
                    <div class="col-12">
                        <img src="layout/images/icons/no_result.png" class="img-fluid"
                            style="max-width: 277px;" />
                        <h3 class="msg-no-filters">{{'messages.info.haveNotFilters' | translate}}</h3>
                    </div>

                    <div class="col-12 mt-10">
                        <button
                            type="button"
                            pButton
                            pRipple
                            icon="pi pi-times"
                            class="p-button-outlined w-100"
                            [label]="'buttons.fechar' | translate"
                            (click)="hideOnAction()"
                            severity="danger"
                        ></button>
                    </div>
                </div>
            </div>
        </ng-template>
        <!-- Possui filtros de pesquisa avançados -->
        <ng-template [ngIf]="canFilter">
            <ng-content select="[filters]"></ng-content>
            <div class="grid grid-cols-12 gap-2 mt-6 filters-actions">
                <div class="col-span-12 col-apply">
                    <button
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-check"
                        (click)="applyOnAction()"
                        [label]="'buttons.aplicarFiltros' | translate"
                        class="w-100"
                    ></button>
                </div>

                <div class="col-span-12">
                    <button
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-ban"
                        class="p-button-outlined w-100"
                        [label]="'buttons.limparFiltros' | translate"
                        (click)="resetOnAction()"
                        severity="danger"
                    ></button>
                </div>
            </div>
        </ng-template>
    </ng-template>
</p-drawer>
